import { render, staticRenderFns } from "./PostMinting.vue?vue&type=template&id=30d826b4&"
import script from "./PostMinting.vue?vue&type=script&lang=js&"
export * from "./PostMinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports